import { computed, inject, Injectable, Signal } from '@angular/core';
import { localDate } from '../../../../shared/pipes/local-date.pipe';
import { WorkGridItemObject } from '@it2go/types';
import { SessionService } from '../../../../../services/session.service';
import { selectCurrentServiceId, selectFolder, selectFolderId } from '../../../store/person/person.selectors';
import { WorkDataServiceRecordObject } from '@libs/types/src/services/object-type/work/work-service-record.object';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../shared/shared.global-service';
import { formatPerson } from '@libs/shared/helpers/person.utils';

@Injectable()
export class FolderServiceRecordsPageStore extends ComponentStoreV2Factory {

    public readonly session = inject(SessionService);

    serviceRecords: Signal<WorkGridItemObject<WorkDataServiceRecordObject>[]> = computed(() => {
        const works = this.data.getWorks()?.['items'] || [];
        return works.map((item: WorkGridItemObject<WorkDataServiceRecordObject>, index: number) => {
            const createdAt = localDate(item.dateFrom, this.session);
            return {
                ...item,
                data: item.workData?.note,
                createdAt,
                index,
                key: createdAt + ' ' + formatPerson(item.users[0]),
            };
        });
    });

    folder = globalStore!.selectSignal(selectFolder);
    folderId = globalStore!.selectSignal(selectFolderId);
    serviceId = globalStore!.selectSignal(selectCurrentServiceId);
}
